import * as React from "react";
import { useTranslation } from "react-i18next";
import { StyledButton } from "../../atoms/button";
import MessageLayout from '../../templetes/messageLayout'
import './style.scss'
const YesConfirmPopup = () => {
  const { t } = useTranslation();
  return (
    <div id="YesConfirmPopupPopup" className="popup-layout-wrap">
      <div className='layout-table' theme='primary'>
        <MessageLayout
          closePopup={closeConfirm}
          theme='primary'
          button={
            <>
              <StyledButton id="confirm_without_no_yes" type='text' data-bg='primary' size='sm'>
                {t("common.yes")}
              </StyledButton>
            </>
          }>
          <div id="yesConfirmPopupBody">

          </div>
        </MessageLayout>
      </div>
    </div>
  );
};

export default YesConfirmPopup;

export const confirm = (message) => {
  if (!document.getElementById("YesConfirmPopupPopup").classList.contains("on")) {
    document.getElementById("yesConfirmPopupBody").innerText = message
    return new Promise((resolve) => {
      document.getElementById("confirm_without_no_yes").addEventListener('click', () => {
        closeConfirm()
        resolve(true)
      }, { once: true })
      document.getElementById("YesConfirmPopupPopup").classList.add("on")
    })


  }
}
const closeConfirm = () => {
  if (document.getElementById("YesConfirmPopupPopup").classList.contains("on")) {
    document.getElementById("YesConfirmPopupPopup").classList.remove("on")
  }
}
